import React from 'react'
import classes from './DutyCell.module.css'
import { Card, Divider, Text } from '@chakra-ui/react'
import DutySlot from '../DutySlot/DutySlot'

function DutyCell({time}) {
    return (
        <Card
            className={classes.container}
            minW='120px'
        >
            {/* <Text whiteSpace='nowrap' fontWeight='bold'>{time && `${time.start_time} - ${time.end_time}`}</Text>
            <Divider /> */}
            {
            time.slots?.length > 0 &&
            time.slots.map((slot) => 
                <DutySlot slot={slot} key={`slot${slot.slot_id}`} />
            )
            }
        </Card>
    )
}

export default DutyCell
